import {post} from "../utils";

export default host => ( clientId, data)  =>
    post(`${host}/clients/${clientId}/contentCreations/countForRekognition`, JSON.stringify(data))
    .then(response => response.json())
    

